<h2 mat-dialog-title>Inserisci logo Mittente</h2>
<hr>
<form [formGroup]="logoForm" (ngSubmit)="onSubmit()">
    <mat-dialog-content>
        <div class="field-container">
            <div *ngIf="logoBase64" id="image-container">
                <img src="{{ logoBase64 }}" width="100%" height="100%"
                    style="border-radius: 50%;" id="logo-img" />
                <!-- {{ logoForm.value.logo?.files[0] | json }} -->
            </div>
            <mat-form-field appearance="outline">
                <mat-label>Logo:</mat-label>
                <ngx-mat-file-input placeholder="Logo" accept="image/*"
                    (change)="handleFileInput($event.target.files[0])">
                </ngx-mat-file-input>
                <mat-icon matSuffix>folder</mat-icon>
            </mat-form-field>
        </div>
    </mat-dialog-content>
    <hr>
    <mat-dialog-actions id="action-div">
        <button mat-stroked-button (click)="closeCancelling()" type="button">Annulla</button>
        <button mat-stroked-button color="primary" type="submit" [disabled]="!logoForm.valid">Inserisci</button>
    </mat-dialog-actions>
</form>